import { QueryBuilder } from 'typeorm';

export class TypeOrmHelper {
  public static parseIds(ids?: string): number[] {
    return ids
      ? ids
          .split(',')
          .map(id => parseInt(id.trim(), 10))
          .filter(id => !isNaN(id))
      : [];
  }

  public static escapeValue(value: any): string {
    if (value == null) {
      return 'NULL';
    } else if (typeof value === 'string') {
      return `'${value.replace(/'/g, "''")}'`;
    } else if (typeof value === 'number' || typeof value === 'boolean') {
      return value.toString();
    } else if (value instanceof Date) {
      return `'${value.toISOString()}'`;
    } else if (Array.isArray(value)) {
      return `(${value.map(v => this.escapeValue(v)).join(', ')})`;
    } else {
      return `'${JSON.stringify(value).replace(/'/g, "''")}'`;
    }
  }

  public static replaceParameters(query: QueryBuilder<any>): string {
    let sql: string;
    try {
      sql = query.getQuery();
    } catch (error) {
      try {
        sql = query.getSql();
      } catch (innerError) {
        console.error('Failed to get SQL query:', innerError);
        return 'Failed to get SQL query';
      }
    }

    const parameters = query.getParameters();
    let positionalParamIndex = 0;

    return sql.replace(
      /(:\.\.\.?\w+)|(:(\w+))|(\?)/g,
      (match, spreadParam, namedParam, paramName, questionMark) => {
        if (spreadParam) {
          // Handle spread operator
          const spreadParamName = spreadParam.replace(/^:\.\.\.*/, '');
          const value = parameters[spreadParamName];
          return Array.isArray(value)
            ? value.map(v => this.escapeValue(v)).join(', ')
            : this.escapeValue(value);
        } else if (namedParam) {
          // Handle named parameters
          return this.escapeValue(parameters[paramName]);
        } else if (questionMark) {
          // Handle positional parameters
          return this.escapeValue(parameters[positionalParamIndex++]);
        }
        return match; // Return the original match if none of the above conditions are met
      }
    );
  }
}
